import React, { useEffect, useState } from 'react';
import ThemeProvider from './lib/ThemeProvider';
import { supabase } from './lib/supabaseClient';
import './App.css';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import DailyVerse from './components/DailyVerse';
import About from './components/About';
import Pastors from './components/Pastors';
import Services from './components/Services';
import Events from './components/Events';
import Sermons from './components/Sermons';
import Gallery from './components/Gallery';
import Testimonials from './components/Testimonials';
import Branches from './components/Branches';
import PrayerRequest from './components/PrayerRequest';
import Give from './components/Give';
import Connect from './components/Connect';
import Footer from './components/Footer';
import Admin from './components/Admin';
import Announcement from './components/Announcement';
import VersePopup from './components/VersePopup';

function App() {
  const [isAdmin, setIsAdmin] = useState(false);
  const [vis, setVis] = useState({}); // default empty = show all (true by default)

  // Load section visibility — don't block rendering
  useEffect(() => {
    supabase.from('section_visibility').select('key,enabled')
      .then(({ data, error }) => {
        if (!error && data && data.length > 0) {
          const map = {};
          data.forEach(r => { map[r.key] = r.enabled; });
          setVis(map);
        }
        // If error or no data — keep default {} which shows all sections
      })
      .catch(() => {}); // silent fail — all sections show by default
  }, []);

  // Show = true by default if key not in map (table not set up yet, or loading)
  const show = (key) => vis[key] === undefined ? true : Boolean(vis[key]);

  // Re-run observer whenever vis changes (sections mount/unmount)
  useEffect(() => {
    if (window.location.pathname.startsWith('/admin')) {
      setIsAdmin(true);
      return;
    }
    // Small delay to let newly rendered sections mount into DOM
    const timer = setTimeout(() => {
      const obs = new IntersectionObserver(entries => {
        entries.forEach((e, i) => {
          if (e.isIntersecting) {
            setTimeout(() => e.target.classList.add('visible'), i * 80);
          }
        });
      }, { threshold: 0.05 });
      document.querySelectorAll('.fade-up:not(.visible)').forEach(el => obs.observe(el));
      return () => obs.disconnect();
    }, 100);
    return () => clearTimeout(timer);
  }, [vis]); // re-runs when vis changes

  if (isAdmin) return <Admin />;

  return (
    <ThemeProvider>
      <Announcement />
      <VersePopup />
      <Navbar />
      <Hero />
      {show('daily_verse')   && <DailyVerse />}
      {show('about')         && <About />}
      {show('pastors')       && <Pastors />}
      {show('services')      && <Services />}
      {show('events')        && <Events />}
      {show('sermons')       && <Sermons />}
      {show('gallery')       && <Gallery />}
      {show('testimonials')  && <Testimonials />}
      {show('branches')      && <Branches />}
      {show('prayer')        && <PrayerRequest />}
      {show('give')          && <Give />}
      {show('connect')       && <Connect />}
      <Footer />
    </ThemeProvider>
  );
}

export default App;
